import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import { type ActionButton } from '@bizzdesign/shared/models';
import { PageHeaderComponent } from '@bizzdesign/ui-page-header';
import { SkeletonModule } from 'primeng/skeleton';
import { CallToActionComponent } from '@bizzdesign/ui-call-to-action';

@Component({
  selector: 'bd-data-management-page',
  imports: [
    PageHeaderComponent,
    SkeletonModule,
    SharedI18nModule,
    CallToActionComponent,
  ],
  templateUrl: './data-management-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataManagementPageComponent {
  private router = inject(Router);
  readonly manageAttributeAction: ActionButton = {
    tScope: 'featureDataManagement',
    labelKey: 'manageAttributes.label',
    onClick: () => this.onManageAttributesButtonClick(),
    type: 'secondary',
    styleClass: 'mr-2',
  };
  readonly importAction: ActionButton = {
    tScope: 'featureDataManagement',
    labelKey: 'dataManagement.importButton',
    onClick: () => this.onImportButtonClick(),
    type: 'primary',
  };

  readonly actionButtonsForHeader: ActionButton[] = [
    this.manageAttributeAction,
    this.importAction,
  ];
  onImportButtonClick() {
    this.router.navigate(['/data-import']);
  }
  onManageAttributesButtonClick() {
    this.router.navigate(['/manage-attributes']);
  }
}
